import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\">\n<path d=\"M6.00182 7.12511C5.84349 7.12511 5.68516 7.06678 5.56016 6.94178L0.560156 1.94178C0.31849 1.70011 0.31849 1.30011 0.560156 1.05845C0.801823 0.816781 1.20182 0.816781 1.44349 1.05845L6.00182 5.61678L10.5602 1.05845C10.8018 0.816781 11.2018 0.816781 11.4435 1.05845C11.6852 1.30011 11.6852 1.70011 11.4435 1.94178L6.44349 6.94178C6.31849 7.06678 6.16016 7.12511 6.00182 7.12511Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol